import React from 'react';

import {place, units} from "./stage";

// A zero-size box at a stage point. Its child is centred on the point (or sits on it with `bottom`),
// which leaves the child's own transform free for animation.
function Anchor({x, y, bottom, children}) {
    return (
        <div className={'v2-anchor' + (bottom ? ' v2-anchor-bottom' : '')} style={place(x, y)}>
            {children}
        </div>
    );
}

function Bubble({x, y, delay, children}) {
    return (
        <Anchor x={x} y={y} bottom>
            <div className='v2-bubble' style={{animationDelay: `${delay}s`}}>{children}</div>
        </Anchor>
    );
}

function Hello() {
    return (
        <>
            <Bubble x={20} y={30} delay={1.4}>Hi!</Bubble>
            <Bubble x={55} y={22} delay={1.8}>Hey!</Bubble>
            <Bubble x={88} y={14} delay={2.2}>Welcome!</Bubble>
        </>
    );
}

const REAL_WORLD = [
    {x: -26, y: 46, symbol: '×', icon: '👕'},
    {x: -18, y: 14, symbol: '+', icon: '🥞'},
    {x: 6, y: -6, symbol: '÷', icon: '🏀'},
    {x: 40, y: -12, symbol: '%', icon: '🎨'},
    {x: 74, y: -10, symbol: 'π', icon: '🚀'},
    {x: 106, y: 2, symbol: '=', icon: '🌱'},
    {x: 114, y: 36, symbol: '½', icon: '🛒'}
];

function What() {
    return REAL_WORLD.map((item, index) => (
        <Anchor key={index} x={item.x} y={item.y}>
            <div className='v2-flip' style={{'--d': `${0.3 + index * 0.18}s`}}>
                <div className='v2-flip-inner'>
                    <span className='v2-flip-front'>{item.symbol}</span>
                    <span className='v2-flip-back'>{item.icon}</span>
                </div>
            </div>
        </Anchor>
    ));
}

function Code() {
    return (
        <Anchor x={42} y={-2}>
            <div className='v2-code-card' style={{width: units(76)}}>
                <div className='v2-code-label'>Class code</div>
                <div className='v2-code-slots'>
                    {Array.from({length: 6}, (value, index) => (
                        <span key={index} className='v2-code-slot'>
                            <span style={{animationDelay: `${0.9 + index * 0.2}s`}}>★</span>
                        </span>
                    ))}
                </div>
                <div className='v2-code-stamp'>You’re in! ✓</div>
            </div>
        </Anchor>
    );
}

const CHECKPOINTS = [[0, 4], [45, 0], [80, -7]];

function Challenge() {
    return (
        <>
            <svg
                className='v2-path'
                viewBox='-35 -20 155 40'
                style={{...place(-35, -20), width: units(155), height: units(40)}}
            >
                <path d='M -25 10 Q -12 -8 0 4 Q 22 22 45 0 Q 62 -18 80 -7 Q 98 4 110 0'/>
            </svg>
            {CHECKPOINTS.map(([x, y], index) => (
                <Anchor key={index} x={x} y={y}>
                    <span className='v2-checkpoint' style={{animationDelay: `${0.8 + index * 0.45}s`}}>✓</span>
                </Anchor>
            ))}
            <Anchor x={110} y={-4}>
                <span className='v2-finish'>🏁</span>
            </Anchor>
            <Anchor x={22} y={24}>
                <span className='v2-question'>?</span>
            </Anchor>
            <Anchor x={22} y={24}>
                <span className='v2-idea'>💡</span>
            </Anchor>
        </>
    );
}

function Share() {
    return (
        <>
            <Bubble x={20} y={30} delay={0.4}><span className='v2-bubble-icon'>✏️</span>Draw</Bubble>
            <Bubble x={55} y={20} delay={1}><span className='v2-bubble-icon'>📊</span>Graph</Bubble>
            <Bubble x={90} y={12} delay={1.6}><span className='v2-bubble-icon'>💬</span>Explain</Bubble>
        </>
    );
}

const CHEERS = ['💛', '⭐', '🎉', '💙', '⭐', '💜', '🎉', '💚'];

function Together() {
    return CHEERS.map((cheer, index) => (
        <Anchor key={index} x={-22 + index * 19} y={34}>
            <span className='v2-cheer' style={{animationDelay: `${index * 0.35}s`}}>{cheer}</span>
        </Anchor>
    ));
}

const PROPS = {
    hello: Hello,
    what: What,
    code: Code,
    challenge: Challenge,
    share: Share,
    together: Together
};

export default function ({scene}) {
    const Props = PROPS[scene];

    return (
        <div className='v2-props' aria-hidden='true'>
            <Props/>
        </div>
    );
}
